import Typography from '@mui/material/Typography';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import TransitionProgressPrompt from '../../../../components/TransitionProgressPrompt/TransitionProgressPrompt';

import {
  TXTCLI_LetXs_go,
  TXTCLI_Welcome_to_XXBrandXX_N0,
  TXTCLI_Your_login_details_have_been_s_ELL,
  TXTWCL_Your_login_details_have_been_s_ELL
} from './RMFWelcomeTransition.messages.json';

interface Props {
  setValue: () => void;
}

const RMFWelcomeTransition: React.FC<Props> = ({ setValue }) => {
  const userId = useSelector(select.account.getUserId);
  const isSwcUSPAEnhancedFlow = useFeature(FeatureFlag.SwcUSPAEnhancedFlow);
  const subtitle = isSwcUSPAEnhancedFlow
    ? TXTWCL_Your_login_details_have_been_s_ELL
    : TXTCLI_Your_login_details_have_been_s_ELL;

  return (
    <TransitionProgressPrompt
      title={{ translation: TXTCLI_Welcome_to_XXBrandXX_N0, values: { 0: userId } }}
      primaryButton={{ translation: TXTCLI_LetXs_go }}
      onPrimaryButtonClick={setValue}
    >
      <Typography>
        <Translation {...subtitle} />
      </Typography>
    </TransitionProgressPrompt>
  );
};

export default RMFWelcomeTransition;
